import { Button, withStyles } from '@material-ui/core';

const RoundedButton = withStyles(theme => ({
  root: {
    borderRadius: 64,
    padding: 6,
    minWidth: 'unset',
    '&.MuiButton-outlinedPrimary': {
      borderWidth: 2,
      borderColor: theme.palette.primary.main,
      '&:hover': {
        opacity: 0.8,
      },
    },
  },
}))(Button);

export default RoundedButton as typeof Button;
